/* Safara Aroma shopping features: cart drawer, live search, quick view, wishlist,
   recently viewed, sticky add-to-bag, back-in-stock, countdown, sign-up popup */
(function () {
  'use strict';

  var T = window.theme || {};
  var S = T.strings || {};
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var money = function (cents) { return T.formatMoney ? T.formatMoney(cents) : (cents / 100).toFixed(2); };
  var esc = function (str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var sizedImage = function (url, width) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  };
  var store = {
    get: function (key) { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } },
    set: function (key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }
  };
  var productCache = {};
  function fetchProduct(handleOrUrl) {
    var url = handleOrUrl.indexOf('/') > -1 ? handleOrUrl.split('?')[0] : T.routes.root_url.replace(/\/$/, '') + '/products/' + handleOrUrl;
    if (!productCache[url]) {
      productCache[url] = fetch(url + '.js').then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return productCache[url];
  }

  /* Simple product card used by wishlist and recently viewed */
  function cardHtml(p) {
    var sale = p.compare_at_price > p.price;
    var price = sale
      ? '<div class="price price--on-sale"><span class="price__current">' + money(p.price) + '</span><s class="price__compare">' + money(p.compare_at_price) + '</s></div>'
      : '<div class="price"><span class="price__current">' + (p.price_varies ? money(p.price_min) : money(p.price)) + '</span></div>';
    return '<li><article class="card">' +
      '<a href="' + esc(p.url) + '" class="card__media">' +
        (p.featured_image ? '<img class="card__img" loading="lazy" src="' + esc(sizedImage(p.featured_image, 600)) + '" alt="' + esc(p.title) + '">' : '') +
      '</a>' +
      (T.settings && T.settings.wishlist ? '<button type="button" class="card__wish" data-wishlist-toggle="' + esc(p.handle) + '" aria-pressed="false"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10Z"/></svg><span class="visually-hidden">Wishlist</span></button>' : '') +
      '<div class="card__info"><p class="card__vendor">' + esc(p.vendor) + '</p><h3 class="card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' + price + '</div>' +
      '<a href="' + esc(p.url) + '" class="button button--ink button--small button--full card__quick-add">' + esc(S.viewDetails || 'View details') + '</a>' +
    '</article></li>';
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var footEl = drawer.querySelector('[data-cart-foot]');
    var meter = drawer.querySelector('[data-cart-meter]');

    var renderCart = function (cart) {
      $$('[data-cart-count], [data-cart-count-inline]').forEach(function (c) {
        c.textContent = cart.item_count;
        if (c.hasAttribute('data-cart-count')) c.classList.toggle('is-empty', cart.item_count === 0);
      });
      drawer.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
      footEl.hidden = cart.item_count === 0;

      var threshold = (T.settings && T.settings.freeShippingThreshold) || 0;
      if (threshold > 0 && cart.item_count > 0) {
        var remaining = threshold - cart.total_price;
        meter.hidden = false;
        meter.querySelector('[data-cart-meter-text]').textContent = remaining > 0
          ? (S.shippingRemaining || '').replace('[amount]', money(remaining))
          : S.shippingUnlocked;
        meter.querySelector('[data-cart-meter-bar]').style.width = Math.min(100, cart.total_price / threshold * 100) + '%';
      } else {
        meter.hidden = true;
      }

      if (!cart.items.length) {
        itemsEl.innerHTML = '<div class="cart-empty"><span class="cart-empty__orb">\u2726</span><p class="empty-state">' + esc(S.cartEmpty) + '</p>' + (S.emptyAi ? '<button type="button" class="button button--gold" data-concierge-open>' + esc(S.emptyAi) + '</button>' : '') + '</div>';
        return;
      }
      itemsEl.innerHTML = cart.items.map(function (item, i) {
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + esc(item.variant_title) + '</p>' : '';
        return '<div class="drawer-item" data-line="' + (i + 1) + '">' +
          '<a href="' + esc(item.url) + '" class="drawer-item__media">' + (item.image ? '<img src="' + esc(sizedImage(item.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="drawer-item__info">' +
            '<p class="card__vendor">' + esc(item.vendor) + '</p>' +
            '<a href="' + esc(item.url) + '" class="drawer-item__title">' + esc(item.product_title) + '</a>' + variant +
            '<div class="drawer-item__row">' +
              '<div class="qty qty--small"><button type="button" class="qty__btn" data-line-change="-1" aria-label="-">&minus;</button><span class="qty__value">' + item.quantity + '</span><button type="button" class="qty__btn" data-line-change="1" aria-label="+">+</button></div>' +
              '<span class="drawer-item__price">' + money(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="drawer-item__remove" data-line-remove>' + esc(S.remove) + '</button>' +
          '</div></div>';
      }).join('');
    };

    var loadCart = function () {
      return fetch(T.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart);
    };
    var changeLine = function (line, quantity) {
      drawer.classList.add('is-loading');
      fetch(T.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(renderCart).finally(function () { drawer.classList.remove('is-loading'); });
    };

    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('[data-line]');
      if (!row) return;
      var line = parseInt(row.dataset.line, 10);
      var qty = parseInt(row.querySelector('.qty__value').textContent, 10);
      if (e.target.closest('[data-line-change]')) changeLine(line, Math.max(0, qty + parseInt(e.target.closest('[data-line-change]').dataset.lineChange, 10)));
      if (e.target.closest('[data-line-remove]')) changeLine(line, 0);
    });

    window.CartDrawer = {
      open: function () { loadCart().then(function () { T.openDrawer('CartDrawer'); }); }
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-open="CartDrawer"]')) loadCart();
    }, true);
    loadCart();
  }

  /* ---------- Predictive search ---------- */
  $$('[data-predictive-search]').forEach(function (form) {
    if (!T.settings || !T.settings.predictiveSearch) return;
    var input = form.querySelector('input[name="q"]');
    var panel = form.querySelector('[data-predictive-results]');
    var timer, lastTerm = '';
    var close = function () { panel.hidden = true; };
    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) { close(); return; }
      timer = setTimeout(function () {
        lastTerm = term;
        var url = T.routes.predictive_search_url + '.json?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          if (term !== lastTerm) return;
          var res = (data.resources && data.resources.results) || {};
          var products = res.products || [];
          var collections = res.collections || [];
          var html = '';
          if (!products.length && !collections.length) {
            html = '<p class="predictive__empty">' + esc((S.noResults || '').replace('[terms]', term)) + '</p>';
          } else {
            if (collections.length) {
              html += '<p class="predictive__label">' + esc(S.collections) + '</p><ul class="predictive__chips">' +
                collections.slice(0, 4).map(function (c) { return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; }).join('') + '</ul>';
            }
            if (products.length) {
              html += '<p class="predictive__label">' + esc(S.products) + '</p><ul class="predictive__list">' +
                products.map(function (p) {
                  var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
                  return '<li><a href="' + esc(p.url) + '" class="predictive__item">' +
                    (img ? '<img src="' + esc(sizedImage(img, 120)) + '" alt="" loading="lazy">' : '<span class="predictive__ph"></span>') +
                    '<span><span class="card__vendor">' + esc(p.vendor) + '</span><span class="predictive__title">' + esc(p.title) + '</span></span>' +
                    '<span class="predictive__price">' + esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</span></a></li>';
                }).join('') + '</ul>';
            }
            html += '<button type="submit" class="predictive__all">' + esc(S.viewAllResults) + ' &rarr;</button>';
          }
          panel.innerHTML = html;
          panel.hidden = false;
        }).catch(close);
      }, 220);
    });
    input.addEventListener('focus', function () { if (panel.innerHTML && input.value.trim().length > 1) panel.hidden = false; });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });

  /* ---------- Quick view ---------- */
  function qvBadges(tags) {
    var t = (tags || []).join(',').toLowerCase();
    var out = '';
    if (/best[- ]?seller/.test(t)) out += '<span class="badge badge--best">' + esc(S.bestseller || 'Best seller') + '</span>';
    if (t.indexOf('trending') > -1) out += '<span class="badge badge--trend">' + esc(S.trending || 'Trending') + '</span>';
    return out ? '<div class="qv__badges">' + out + '</div>' : '';
  }
  var qv = document.querySelector('[data-quick-view-modal]');
  if (qv) {
    var content = qv.querySelector('[data-quick-view-content]');
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      btn.setAttribute('aria-busy', 'true');
      fetchProduct(btn.dataset.quickView).then(function (p) {
        var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        var options = p.variants.length > 1
          ? '<label class="qv__label" for="QvVariant">' + esc(p.options.map(function (o) { return o.name || o; }).join(' / ')) + '</label>' +
            '<select id="QvVariant" class="select" data-qv-variant>' + p.variants.map(function (v) {
              return '<option value="' + v.id + '"' + (v.id === first.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + ' - ' + money(v.price) + (v.available ? '' : ' (' + esc(S.soldOut) + ')') + '</option>';
            }).join('') + '</select>'
          : '<input type="hidden" value="' + first.id + '" data-qv-variant>';
        var desc = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        if (desc.length > 220) desc = desc.slice(0, 220) + '...';
        content.innerHTML =
          '<div class="qv">' +
            '<div class="qv__media">' + (p.featured_image ? '<img src="' + esc(sizedImage(p.featured_image, 800)) + '" alt="' + esc(p.title) + '">' : '') + '</div>' +
            '<div class="qv__info">' +
              qvBadges(p.tags) +
              '<p class="product__vendor">' + esc(p.vendor) + '</p>' +
              '<h2 class="product__title">' + esc(p.title) + '</h2>' +
              '<p class="qv__price" data-qv-price>' + money(first.price) + '</p>' +
              (desc ? '<p class="qv__desc">' + esc(desc) + '</p>' : '') +
              '<form class="qv__form" data-ajax-cart action="' + esc(T.routes.cart_add_url) + '" method="post">' +
                options.replace('data-qv-variant', 'data-qv-variant name="id"') +
                '<input type="hidden" name="quantity" value="1">' +
                '<button type="submit" class="button button--ink button--full" data-qv-add' + (first.available ? '' : ' disabled') + '>' + esc(first.available ? S.addToCart : S.soldOut) + '</button>' +
              '</form>' +
              '<a href="' + esc(p.url) + '" class="link-underline">' + esc(S.viewDetails) + '</a>' +
            '</div>' +
          '</div>';
        var select = content.querySelector('select[data-qv-variant]');
        if (select) select.addEventListener('change', function () {
          var v = p.variants.find(function (x) { return String(x.id) === select.value; });
          content.querySelector('[data-qv-price]').textContent = money(v.price);
          var add = content.querySelector('[data-qv-add]');
          add.disabled = !v.available;
          add.textContent = v.available ? S.addToCart : S.soldOut;
          if (v.featured_image) content.querySelector('.qv__media img').src = sizedImage(v.featured_image.src, 800);
        });
        T.openDrawer('QuickView');
      }).catch(function () { window.location.href = btn.dataset.quickView; })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    });
    document.addEventListener('cart:added', function () {
      if (qv.classList.contains('is-open')) T.closeDrawer(qv);
    });
  }

  /* ---------- Wishlist ---------- */
  var WISH = 'aurelle:wishlist';
  function syncWishlist() {
    var list = store.get(WISH);
    $$('[data-wishlist-toggle]').forEach(function (b) {
      var on = list.indexOf(b.dataset.wishlistToggle) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-wishlist-count]').forEach(function (c) {
      c.textContent = list.length;
      c.classList.toggle('is-empty', list.length === 0);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    var list = store.get(WISH);
    var h = b.dataset.wishlistToggle;
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    store.set(WISH, list.slice(0, 50));
    syncWishlist();
    var page = document.querySelector('[data-wishlist-page]');
    if (page && i > -1) renderWishlistPage();
  });
  function renderWishlistPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');
    var list = store.get(WISH);
    if (!list.length) { grid.innerHTML = ''; empty.hidden = false; return; }
    empty.hidden = true;
    Promise.all(list.map(function (h) { return fetchProduct(h).catch(function () { return null; }); })).then(function (products) {
      grid.innerHTML = products.filter(Boolean).map(cardHtml).join('');
      syncWishlist();
    });
  }

  /* ---------- Recently viewed ---------- */
  var RECENT = 'aurelle:recent';
  var current = document.querySelector('[data-product-handle]');
  var currentHandle = current ? current.dataset.productHandle : null;
  if (currentHandle) {
    var recent = store.get(RECENT).filter(function (h) { return h !== currentHandle; });
    recent.unshift(currentHandle);
    store.set(RECENT, recent.slice(0, 12));
  }
  function renderRecent(root) {
    $$('[data-recently-viewed]', root).forEach(function (sec) {
      var limit = parseInt(sec.dataset.limit, 10) || 4;
      var list = store.get(RECENT).filter(function (h) { return h !== currentHandle; }).slice(0, limit);
      if (!list.length) return;
      Promise.all(list.map(function (h) { return fetchProduct(h).catch(function () { return null; }); })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;
        sec.querySelector('[data-recently-viewed-grid]').innerHTML = products.map(cardHtml).join('');
        sec.hidden = false;
        syncWishlist();
      });
    });
  }

  /* ---------- Product page: sticky bar and back-in-stock ---------- */
  $$('[data-product]').forEach(function (el) {
    var buy = el.querySelector('.product__buy');
    var bar = document.querySelector('[data-sticky-atc]');
    var mainBtn = el.querySelector('[data-add-button]');
    var notify = el.querySelector('[data-notify]');
    if (bar && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      }).observe(buy);
      bar.querySelector('[data-sticky-add]').addEventListener('click', function () { if (mainBtn && !mainBtn.disabled) mainBtn.click(); });
    }
    el.addEventListener('variant:change', function (e) {
      var v = e.detail.variant;
      if (bar) {
        bar.querySelector('[data-sticky-price]').textContent = e.detail.price + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
        var b = bar.querySelector('[data-sticky-add]');
        b.disabled = !v.available;
      }
      if (notify) {
        notify.hidden = v.available;
        var body = notify.querySelector('[data-notify-body]');
        if (body) body.value = body.value.replace(/ - .*$/, ' - ' + v.title);
      }
    });
  });

  /* ---------- Countdown ---------- */
  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      var raw = (el.dataset.countdown || '').trim().replace(' ', 'T');
      var end = new Date(raw).getTime();
      if (isNaN(end)) return;
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var tick = function () {
        var diff = Math.max(0, end - Date.now());
        if (diff === 0 && el.dataset.hideExpired === 'true' && !window.Shopify?.designMode) { el.hidden = true; clearInterval(t); }
        var s = Math.floor(diff / 1000);
        el.querySelector('[data-cd="d"]').textContent = pad(Math.floor(s / 86400));
        el.querySelector('[data-cd="h"]').textContent = pad(Math.floor(s % 86400 / 3600));
        el.querySelector('[data-cd="m"]').textContent = pad(Math.floor(s % 3600 / 60));
        el.querySelector('[data-cd="s"]').textContent = pad(s % 60);
      };
      var t = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Sign-up popup ---------- */
  function initPopup(root, force) {
    var pop = (root || document).querySelector('[data-popup]');
    if (!pop) return;
    var KEY = 'aurelle:popup';
    var days = parseInt(pop.dataset.days, 10) || 7;
    var posted = pop.querySelector('.newsletter__success');
    if (posted) { T.openDrawer('NewsletterPopup'); }
    if (!force && !posted) {
      if (window.Shopify && window.Shopify.designMode) return;
      var last = 0;
      try { last = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
      if (Date.now() - last < days * 86400000) return;
      setTimeout(function () { T.openDrawer('NewsletterPopup'); }, (parseInt(pop.dataset.delay, 10) || 6) * 1000);
    }
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { try { localStorage.setItem(KEY, String(Date.now())); } catch (err) {} }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncWishlist();
    renderWishlistPage();
    renderRecent(document);
    initCountdowns(document);
    initPopup(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    syncWishlist();
    renderRecent(e.target);
    initCountdowns(e.target);
    if (e.target.querySelector('[data-popup]')) initPopup(e.target, true);
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-popup]')) T.openDrawer('NewsletterPopup');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var p = e.target.querySelector('[data-popup]');
    if (p) T.closeDrawer(p);
  });
})();

/* Size chips on cards, delivery estimate, chat button */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-size-chip]');
    if (chip) {
      var card = chip.closest('.card');
      card.querySelectorAll('[data-size-chip]').forEach(function (c) {
        c.classList.toggle('is-active', c === chip);
        c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
      });
      var input = card.querySelector('[data-card-variant]');
      if (input) input.value = chip.dataset.variantId;
      var price = card.querySelector('[data-card-price]');
      if (price) {
        price.innerHTML = '<div class="price' + (chip.dataset.compare ? ' price--on-sale' : '') + '"><span class="price__current"></span>' + (chip.dataset.compare ? '<s class="price__compare"></s>' : '') + '</div>';
        price.querySelector('.price__current').textContent = chip.dataset.price;
        if (chip.dataset.compare) price.querySelector('.price__compare').textContent = chip.dataset.compare;
      }
    }
    var toggle = e.target.closest('[data-chat-toggle]');
    if (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
    } else if (!e.target.closest('[data-chat]') || e.target.closest('[data-chat] [data-concierge-open]')) {
      var open = document.querySelector('.chat__panel:not([hidden])');
      if (open) { open.hidden = true; document.querySelector('[data-chat-toggle]').setAttribute('aria-expanded', 'false'); }
    }
  });

  function addWorkingDays(date, days) {
    var d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  }
  function initDelivery(root) {
    (root || document).querySelectorAll('[data-delivery-estimate]').forEach(function (el) {
      var now = new Date();
      var start = new Date(now);
      var cutoff = parseInt(el.dataset.cutoff, 10) || 14;
      if (now.getHours() >= cutoff || now.getDay() === 0 || now.getDay() === 6) start = addWorkingDays(now, 1);
      var from = addWorkingDays(start, parseInt(el.dataset.minDays, 10) || 2);
      var to = addWorkingDays(start, parseInt(el.dataset.maxDays, 10) || 3);
      var fmt = function (d) { return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' }); };
      var out = el.querySelector('[data-delivery-dates]');
      if (out) out.textContent = fmt(from) + ' – ' + fmt(to) + '.';
    });
  }
})();

/* Dispatch countdown and delivery dates (Europe/London working days, UK bank holidays) */
(function () {
  'use strict';
  /* England and Wales bank holidays (gov.uk). Extra closed days come from the block setting. */
  var HOLIDAYS = ['2025-12-25','2025-12-26','2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31','2026-12-25','2026-12-28',
    '2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28'];
  function key(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function isWorking(d, closed) { return d.getDay() !== 0 && d.getDay() !== 6 && closed.indexOf(key(d)) === -1; }
  function nextWorking(d, closed) { var x = new Date(d); do { x.setDate(x.getDate() + 1); } while (!isWorking(x, closed)); return x; }
  function addWorking(d, n, closed) { var x = new Date(d); while (n > 0) { x = nextWorking(x, closed); n--; } return x; }
  /* Wall-clock time in London, whatever the shopper's own time zone */
  function ukNow() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
        .formatToParts(window.__ukNowOverride || new Date()).forEach(function (x) { p[x.type] = x.value; });
      return new Date(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
    } catch (e) { return new Date(); }
  }
  var fmt = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); };
  function tick(root) {
    (root || document).querySelectorAll('[data-delivery-estimate]').forEach(function (box) {
      var cutoff = parseInt(box.dataset.cutoff, 10) || 14;
      var closed = HOLIDAYS.concat((box.dataset.closed || '').split(/[\s,]+/).filter(Boolean));
      var now = ukNow();
      var dispatchToday = isWorking(now, closed) && now.getHours() < cutoff;
      var dispatch = dispatchToday ? now : nextWorking(now, closed);
      var sd = box.querySelector('[data-delivery-dates]');
      if (sd) sd.textContent = fmt(addWorking(dispatch, parseInt(box.dataset.minDays, 10) || 2, closed)) + ' – ' + fmt(addWorking(dispatch, parseInt(box.dataset.maxDays, 10) || 3, closed)) + '.';
      var nd = box.querySelector('[data-nextday-date]');
      if (nd) nd.textContent = fmt(dispatch) + '.';
      var timer = box.querySelector('[data-nextday]');
      if (!timer) return;
      var live = timer.querySelector('[data-nextday-live]');
      var later = timer.querySelector('[data-nextday-later]');
      if (dispatchToday) {
        var end = new Date(now); end.setHours(cutoff, 0, 0, 0);
        var mins = Math.max(1, Math.ceil((end - now) / 60000));
        timer.querySelector('[data-nextday-time]').textContent = (mins >= 60 ? Math.floor(mins / 60) + 'h ' : '') + (mins % 60) + 'm';
        live.hidden = false; later.hidden = true;
      } else {
        timer.querySelector('[data-nextday-day]').textContent = fmt(dispatch);
        live.hidden = true; later.hidden = false;
      }
      timer.hidden = false;
    });
  }
  window.SafaraDelivery = { tick: tick, ukNow: ukNow };
  document.addEventListener('DOMContentLoaded', function () { tick(document); setInterval(function () { tick(document); }, 30000); });
  document.addEventListener('shopify:section:load', function (e) { tick(e.target); });
})();

/* Gift option and bundle deal */
(function () {
  'use strict';
  var T = window.theme || {};
  document.addEventListener('change', function (e) {
    var g = e.target.closest('[data-gift-toggle]');
    if (g) {
      var box = g.closest('[data-gift]');
      var fields = box.querySelector('[data-gift-fields]');
      var msg = box.querySelector('[data-gift-message]');
      fields.hidden = !g.checked;
      msg.disabled = !g.checked;
      if (g.checked) msg.focus();
    }
    var b = e.target.closest('[data-bundle-item]');
    if (b) updateBundle(b.closest('[data-bundle]'));
  });
  document.addEventListener('input', function (e) {
    var msg = e.target.closest('[data-gift-message]');
    if (msg) msg.closest('[data-gift]').querySelector('[data-gift-count]').textContent = msg.value.length;
  });

  function updateBundle(el) {
    var total = 0;
    el.querySelectorAll('[data-bundle-item]').forEach(function (i) {
      i.closest('.bundle__item').classList.toggle('is-off', !i.checked);
      if (i.checked) total += parseInt(i.dataset.price, 10) || 0;
    });
    var fm = function (c) { return T.formatMoney ? T.formatMoney(c) : '£' + (c / 100).toFixed(2); };
    el.querySelector('[data-bundle-total]').textContent = fm(total);
    var deal = el.querySelector('[data-bundle-deal]'), pct = parseInt(el.dataset.bundlePercent, 10) || 0;
    if (deal) deal.textContent = fm(Math.floor(total * (100 - pct) / 100));
  }

  /* Keep "this item" in step with the size picked above */
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    document.querySelectorAll('[data-bundle]').forEach(function (el) {
      var cur = el.querySelector('[data-bundle-current]');
      cur.dataset.variantId = v.id;
      cur.dataset.price = v.price;
      var p = el.querySelector('[data-bundle-current-price]');
      if (p) p.textContent = e.detail.price;
      updateBundle(el);
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-add]');
    if (!btn) return;
    var el = btn.closest('[data-bundle]');
    var items = [];
    el.querySelectorAll('[data-bundle-item]').forEach(function (i) {
      if (i.checked) items.push({ id: parseInt(i.dataset.variantId, 10), quantity: 1 });
    });
    if (items.length < 2) { if (T.toast) T.toast((T.strings && T.strings.bundleSelect) || 'Choose at least one extra item'); return; }
    btn.setAttribute('aria-busy', 'true');
    fetch((T.routes ? T.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { if (T.toast) T.toast(res.data.description || res.data.message || 'Error'); return; }
        var code = el.dataset.bundleCode;
        /* Applying the code here means the bundle saving is already in place at checkout */
        var applied = code ? fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
        return applied.then(function () {
          if (T.updateCartCount) T.updateCartCount();
          if (window.CartDrawer) window.CartDrawer.open(); else if (T.toast) T.toast((T.strings && T.strings.bundleAdded) || 'Added');
          document.dispatchEvent(new CustomEvent('cart:added', { detail: res.data }));
        });
      })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });
})();
